// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cbk-breadcrumbs ol{max-height:2rem !important}`, "",{"version":3,"sources":["webpack://./src/components/RightPanel/ExtractDetail/ExtractNavigation/Style.scss"],"names":[],"mappings":"AACE,oBACE,0BAAA","sourcesContent":[".cbk-breadcrumbs {\n  ol {\n    max-height: 2rem !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
